import { PopupTypes } from '../utils/constants';

const initialState = {
};

function app(state = initialState, action) { // NOSONAR: file intentionally named popupsReducer to match domain
    switch (action.type) {
        case 'POPUP:SHOW': {
            const { popup, entityType, id, playerName, savedListIds, singleStep, onClosePopup, onSuccess, onPaymentAttempted, redirectTo, referringSurface, gatedFeature, renewalDate, prismicTitle, referralCode, plansOffered, showHotelPlannerCard } = action;
            return {
                ...state,
                [popup]: true,
                entityType,
                id,
                playerName,
                savedListIds,
                singleStep,
                [`${popup}OnClosePopup`]: onClosePopup,
                [`${popup}OnSuccess`]: onSuccess,
                [`${popup}OnPaymentAttempted`]: onPaymentAttempted,
                [`${popup}RedirectTo`]: redirectTo,
                redirectTo,
                referringSurface,
                gatedFeature,
                renewalDate,
                prismicTitle,
                referralCode,
                plansOffered,
                showHotelPlannerCard,
            };
        }

        case 'POPUP:CLOSE': {
            const { popup } = action;
            const nextState = {
                ...state,
                [popup]: false,
                [`${popup}OnClosePopup`]: null,
                [`${popup}OnSuccess`]: null,
                [`${popup}OnPaymentAttempted`]: null,
                [`${popup}RedirectTo`]: null,
                redirectTo: null,
                referringSurface: null,
                gatedFeature: null,
                prismicTitle: null,
                referralCode: null,
                plansOffered: null,
                showHotelPlannerCard: null,
            };
            if (popup === PopupTypes.POWER_MONTHLY_UPGRADE_SUCCESS_POPUP) {
                delete nextState.renewalDate;
            }
            return nextState;
        }

        default:
            return state;
    }
}

export default app;
